<form [formGroup]="addressForm">
  <ion-grid>
    <ion-row class="ion-align-items-center ion-justify-content-center">
      <!-- form -->
      <ion-col size="12" background-white-md-up>
        <ion-row class="ion-align-items-center ion-justify-content-start" max-width-form max-width-form-md-up>
          <ion-col sizeXs="12" sizeXl="6" sizeSm="12" sizeMd="6" sizeLg="6">
            <ion-label position="stacked">{{ 'COMPONENTS.FORMS.CEP' | translate }}</ion-label>
            <ion-input
              type="tel"
              formControlName="zipCode"
              placeholder="{{ 'COMPONENTS.FORMS.INSERT_THE_CEP' | translate }}"
              mask="zip"
              dropSpecialCharacters
            >
              <ion-icon
                class="suffix-icon"
                src="assets/svg/edit-icon.svg"
                item-right
                *ngIf="editMode"
              ></ion-icon>
            </ion-input>

            <ion-note color="danger" *ngIf="zipCode.dirty && zipCode.errors?.required">
              {{ 'COMPONENTS.FORMS.ENTER_THE_CEP' | translate }}
            </ion-note>

            <ion-note
              color="danger"
              *ngIf="zipCode.dirty && !zipCode.errors?.required && zipCode.errors?.invalidCep"
            >
              {{ 'COMPONENTS.FORMS.INVALID_CEP' | translate }}
            </ion-note>
          </ion-col>

          <ion-col sizeXs="12" sizeXl="6" sizeSm="12" sizeMd="6" sizeLg="6">
            <ion-label position="stacked">{{ 'COMPONENTS.FORMS.STATE' | translate }}</ion-label>

            <ionic-selectable
              formControlName="state"
              [items]="statesList"
              itemValueField="sigla"
              itemTextField="nome"
              [canSearch]="true"
              clearButtonText="{{ 'COMPONENTS.FORMS.CLEAR' | translate }}"
              closeButtonSlot="end"
              searchPlaceholder="{{ 'COMPONENTS.FORMS.SEARCH' | translate }}"
              modalCssClass="modal-address"
              (onSearch)="searchState($event)"
              (onChange)="stateSelected($event)"
              placeholder="{{ 'NEW_USER.INFORM_THE_STATE' | translate }}"
            >
              <ng-template ionicSelectableTitleTemplate>
                <h3 class="ion-text-center ion-text-uppercase text-primary-dark">
                  {{ 'COMPONENTS.FORMS.SELECT_THE_STATE' | translate }}
                </h3>
              </ng-template>
              <ng-template ionicSelectableCloseButtonTemplate>
                <ion-icon name="close" color="primary-dark" style="font-size: 24px"></ion-icon>
              </ng-template>
              <ng-template ionicSelectableSearchFailTemplate>
                <div flex class="ion-align-items-center ion-justify-content-center">
                  <h3 class="ion-text-center text-primary-dark ion-no-margin">
                    {{ 'COMPONENTS.FORMS.NO_STATUS_FOUND' | translate }}
                  </h3>
                </div>
              </ng-template>
            </ionic-selectable>

            <ion-note color="danger" *ngIf="state.dirty && state.errors?.required">
              {{ 'COMPONENTS.FORMS.INSERT_STATE' | translate }}
            </ion-note>
          </ion-col>

          <ion-col sizeXs="12" sizeXl="6" sizeSm="12" sizeMd="6" sizeLg="6">
            <ion-label position="stacked">{{ 'COMPONENTS.FORMS.CITY' | translate }}</ion-label>
            <ionic-selectable
              formControlName="city"
              [items]="citiesList"
              itemValueField="normalized"
              itemTextField="nome"
              [canSearch]="true"
              [hasInfiniteScroll]="true"
              clearButtonText="{{ 'COMPONENTS.FORMS.CLEAR' | translate }}"
              closeButtonSlot="end"
              searchPlaceholder="{{ 'COMPONENTS.FORMS.SEARCH' | translate }}"
              modalCssClass="modal-address"
              (onSearch)="searchCities($event)"
              (onInfiniteScroll)="getMoreCities($event)"
              placeholder="{{ 'NEW_USER.INFORM_CITY' | translate }}"
            >
              <ng-template ionicSelectableTitleTemplate>
                <h3 class="ion-text-center ion-text-uppercase text-primary-dark">{{
                  'COMPONENTS.FORMS.SELECT_THE_CITY' | translate
                }}</h3>
              </ng-template>
              <ng-template ionicSelectableCloseButtonTemplate>
                <ion-icon name="close" color="primary-dark" style="font-size: 24px"></ion-icon>
              </ng-template>
              <ng-template ionicSelectableSearchFailTemplate>
                <div flex class="ion-align-items-center ion-justify-content-center">
                  <h3 class="ion-text-center text-primary-dark ion-no-margin">
                    {{ 'COMPONENTS.FORMS.NO_CITY_FOUND' | translate }}
                  </h3>
                </div>
              </ng-template>
            </ionic-selectable>

            <ion-note color="danger" *ngIf="city.dirty && city.errors?.required">
              {{ 'COMPONENTS.FORMS.INSERT_CITY' | translate }}
            </ion-note>
          </ion-col>

          <ion-col sizeXs="12" sizeXl="6" sizeSm="12" sizeMd="6" sizeLg="6">
            <ion-label position="stacked">{{ 'COMPONENTS.FORMS.NEIGHBORHOOD' | translate }}</ion-label>
            <ion-input
              type="text"
              formControlName="neighborhood"
              placeholder="{{ 'COMPONENTS.FORMS.ENTER_THE_NEIGHBORHOOD' | translate }}"
            >
              <ion-icon
                class="suffix-icon"
                src="assets/svg/edit-icon.svg"
                item-right
                *ngIf="editMode"
              ></ion-icon
            ></ion-input>

            <ion-note color="danger" *ngIf="neighborhood.dirty && neighborhood.errors?.required">
              {{ 'COMPONENTS.FORMS.INSERT_THE_NEIGHBORHOOD' | translate }}
            </ion-note>

            <ion-note color="danger" *ngIf="neighborhood.dirty && neighborhood.errors?.maxlength">
              {{ 'COMPONENTS.FORMS.THE_NEIGHBORHOOD_MUST_HAVE_AT_MOST' | translate }}
              {{ neighborhood.errors.maxlength.requiredLength }}
              {{ 'COMPONENTS.FORMS.CHARACTERS' | translate }}
            </ion-note>
          </ion-col>

          <ion-col sizeXs="12" sizeXl="6" sizeSm="12" sizeMd="6" sizeLg="6">
            <ion-label position="stacked">{{ 'COMPONENTS.FORMS.ADDRESS' | translate }}</ion-label>
            <ion-input
              type="text"
              formControlName="street"
              placeholder="{{ 'COMPONENTS.FORMS.ENTER_THE_ADDRESS' | translate }}"
            >
              <ion-icon
                class="suffix-icon"
                src="assets/svg/edit-icon.svg"
                item-right
                *ngIf="editMode"
              ></ion-icon>
            </ion-input>

            <ion-note color="danger" *ngIf="street.dirty && street.errors?.required">
              {{ 'COMPONENTS.FORMS.INSERT_THE_ADDRESS' | translate }}
            </ion-note>

            <ion-note color="danger" *ngIf="street.dirty && street.errors?.maxlength">
              {{ 'COMPONENTS.FORMS.THE_ADDRESS_MUST_HAVE_AT_MOST' | translate }}
              {{ street.errors.maxlength.requiredLength }} {{ 'COMPONENTS.FORMS.CHARACTERS' | translate }}
            </ion-note>
          </ion-col>

          <ion-col sizeXs="12" sizeXl="6" sizeSm="12" sizeMd="6" sizeLg="6">
            <ion-label position="stacked">{{ 'COMPONENTS.FORMS.NUMBER' | translate }}</ion-label>
            <ion-input
              type="tel"
              formControlName="streetNumber"
              placeholder="{{ 'COMPONENTS.FORMS.ENTER_THE_NUMBER' | translate }}"
            >
              <ion-icon
                class="suffix-icon"
                src="assets/svg/edit-icon.svg"
                item-right
                *ngIf="editMode"
              ></ion-icon>
            </ion-input>

            <ion-note color="danger" *ngIf="streetNumber.dirty && streetNumber.errors?.required">
              {{ 'COMPONENTS.FORMS.INSERT_THE_NUMBER' | translate }}
            </ion-note>

            <ion-note color="danger" *ngIf="streetNumber.dirty && streetNumber.errors?.maxlength">
              {{ 'COMPONENTS.FORMS.THE_NUMBER_MUST_HAVE_AT_MOST' | translate }}
              {{ streetNumber.errors.maxlength.requiredLength
              }}{{ 'COMPONENTS.FORMS.CHARACTERS' | translate }}
            </ion-note>
          </ion-col>

          <ion-col sizeXs="12" sizeXl="6" sizeSm="12" sizeMd="6" sizeLg="6">
            <ion-label position="stacked">{{ 'COMPONENTS.FORMS.COMPLEMENT' | translate }}</ion-label>
            <ion-input
              type="text"
              formControlName="complement"
              placeholder="{{ 'COMPONENTS.FORMS.INSERT_THE_COMPLEMENT' | translate }}"
            >
              <ion-icon
                class="suffix-icon"
                src="assets/svg/edit-icon.svg"
                item-right
                *ngIf="editMode"
              ></ion-icon>
            </ion-input>

            <ion-note color="danger" *ngIf="complement.dirty && complement.errors?.maxlength">
              {{ 'COMPONENTS.FORMS.THE_COMPLEMENT_MUST_HAVE_AT_MOST' | translate }}
              {{ complement.errors.maxlength.requiredLength }} {{ 'COMPONENTS.FORMS.CHARACTERS' | translate }}
            </ion-note>
          </ion-col>

          <ion-col sizeXs="12" sizeXl="6" sizeSm="12" sizeMd="6" sizeLg="6" *ngIf="showReference">
            <ion-label position="stacked">{{ 'COMPONENTS.FORMS.REFERENCE' | translate }}</ion-label>
            <ion-input
              type="text"
              formControlName="reference"
              placeholder="{{ 'COMPONENTS.FORMS.INSERT_THE_REFERENCE' | translate }}"
            >
              <ion-icon
                class="suffix-icon"
                src="assets/svg/edit-icon.svg"
                item-right
                *ngIf="editMode"
              ></ion-icon>
            </ion-input>

            <ion-note color="danger" *ngIf="reference.dirty && reference.errors?.maxlength">
              {{ 'COMPONENTS.FORMS.THE_REFERENCE_MUST_HAVE_AT_MOST' | translate }}
              {{ reference.errors.maxlength.requiredLength }} {{ 'COMPONENTS.FORMS.CHARACTERS' | translate }}
            </ion-note>
          </ion-col>

          <ion-col size="12" class="ion-no-padding ion-margin-top ion-hide-md-up">
            <ion-button *ngIf="showButton" expand="block" color="buttonPrimary">{{
              'COMPONENTS.FORMS.SAVE' | translate
            }}</ion-button>
          </ion-col>
        </ion-row>
      </ion-col>
      <ion-row
        class="ion-align-items-center ion-padding-horizontal ion-justify-content-end ion-hide-sm-down"
        width-100
      >
        <ion-col size="12" class="ion-no-padding ion-margin-top ion-text-end">
          <ion-button *ngIf="showButton" color="primary" width-300>{{
            'COMPONENTS.FORMS.SAVE' | translate
          }}</ion-button>
        </ion-col>
      </ion-row>
    </ion-row>
  </ion-grid>
</form>

<ng-template #notFoundTemplateRef let-attrs="attrs">
  <span [innerHTML]="'COMPONENTS.FORMS.NO_RESULTS_FOUND' | translate"></span>
</ng-template>
